import CallCenterfilters from "./CallCenterFilters/CallCenterfilters";
import GeneratePdf from "./GeneratePdf";
import Main from "./Main";
import NpsFilters from "./NpsFilters";

const Drawer = {
  Main,
  NpsFilters,
  GeneratePdf,
  CallCenterfilters,
};

export default Drawer;
